import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  change as formFieldChange,
  reset as formReset,
  formValueSelector,
  destroy,
} from 'redux-form';
import { createBasket, updateBasket } from '@store/basket/actions';
import { setJourneyParams } from '@store/yourJourney/actions';

import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';

import { TablesContainer } from './TablesContainer';

const tableFormSelector = formValueSelector('tableForm');
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      formFieldChange,
      formReset,
      createBasket,
      updateBasket,
      setJourneyParams,
      destroy,
      changeJourneyParam,
    },
    dispatch
  );

const mapStateToProps = (state) => {
  const restaurant = tableFormSelector(state, 'restaurant');
  const tableFormStartDate = tableFormSelector(state, 'startDate');
  return {
    restaurant,
    property: entitySelectors.getProperty(state),
    journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
    basketDetails: basketSelectors.getBasketDetails(state),
    tablesPage: entitySelectors.getTablesPage(state),
    tableFormStartDate,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablesContainer as any) as any;
